import script from "./DrawLogsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawLogsView.vue?vue&type=script&setup=true&lang=js"

import "./DrawLogsView.vue?vue&type=style&index=0&id=11a03479&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a03479"]])

export default __exports__